import serviceBase from './serviceBase';
import { EndPoint } from '../appConfig';

var TenantService = Object.create(
    new serviceBase(EndPoint.Tenant)
);
/**
 * 自身のテナント情報を取得します。
 */
TenantService.getMyTenantInfo = function () {
    return this.get();
}
export default TenantService;